

export const SET_ERROR = "@access/SET_ERROR";
export const RESET_ERROR = "@access/RESET_ERROR";
export const SET_ERROR_MESSAGE = "@access/SET_ERROR_MESSAGE";

export const SET_SELECTED_ID = "@access/SET_SELECTED_ID";
export const SET_ROLES = "@access/SET_ROLES";
export const RESET_SELECTED_ID = "@access/RESET_SELECTED_ID";